import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';
import {ResponseData} from '../../nest-responses';

@Injectable()
export class SfPayrollProvider {

  private readonly service: string = 'payroll';
  private readonly model: string = 'SFPayroll';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public updateSchedule(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'updateSchedule';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getSchedule(companyId: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getSchedule';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof companyId !== 'undefined' && companyId !== null) urlParams.companyId = companyId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getPayrollAuth(payload: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'PayrollAuth';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof payload !== 'undefined' && payload !== null) urlParams.params = payload;

    const url = this.nestApiProvider.urlBuilder(method, 'sfpayroll', func, params, urlParams, '');
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public clearFileGenerated(): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'clearfilegenerated';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public stopProcessPayroll(payload: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'stopProcessPayroll';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sf-payroll/sf-payroll.ts